import React from 'react';
import { observer } from 'mobx-react';

import { PortalLink } from 'apps/client/components/PortalLink';
import { ProductQuoteApp } from 'apps/productQuote/app';
import { CadPreview, makeDecimalIdLink } from 'libs/connection/cells';
import { formatPrice } from 'utils/formatStrings';
import { ProductQuoteBuildDetailsCell } from 'apps/productQuote/cells';

export const columns = [
  {
    Header: 'Preview',
    accessor: '',
    Cell: function preview(pq: any) {
      // In the 2 column (Preview, Part Name) we get the file from the 'for' property
      // we might also want to get the file from the 'from.jobSpec' property e.g. for greater user recognition
      // In practice, the 'from.jobSpec' property is the same as the 'for' property as the build file is not
      // changed during the quoting process (for now). So we use the for property to avoid overfetching.
      const { file } = pq.for.build;
      return (
        <PortalLink
          name='rfq'
          params={{ rfqId: pq.from.id }}
          // onClick={onCellClicked}
        >
          {file ? CadPreview(file) : <p>Cannot get preview...</p>}
        </PortalLink>
      );
    },
  },
  {
    Header: 'RFQ ID',
    accessor: 'from.id',
    Cell: function rfqId(id: string) {
      return makeDecimalIdLink({
        routeName: 'rfq',
        paramName: 'rfqId',
        prefix: 'R',
      })(id);
    },
  },
  {
    Header: 'Part Name',
    accessor: 'for.build.file',
    Cell: function PartName(file: any) {
      return file.filename;
    },
  },
  {
    Header: 'Part Details',
    accessor: '',
    Cell: ProductQuoteBuildDetailsCell,
  },
  {
    Header: 'Quantity',
    // isNumeric: true,
    accessor: '',
    dataContentTestId: 'quantity',
    Cell: function quantityCell(productQuote: ProductQuoteApp) {
      return productQuote.for.quantity;
    },
  },
  {
    Header: 'Unit Price',
    // isNumeric: true,
    accessor: '',
    dataContentTestId: 'unit-price',
    Cell: function unitCost(productQuote: ProductQuoteApp) {
      return formatPrice(
        productQuote.finalUnitCost / 100,
        productQuote.currency,
      );
    },
  },
  {
    Header: 'Total Price',
    dataContentTestId: 'total-price',
    accessor: '',
    Cell: function totalCostCell(productQuote: ProductQuoteApp) {
      // const isFilledLocalProductQuote = productQuote.cost !== '';
      // if (productQuote.id || isFilledLocalProductQuote) {
      //   return formatPrice(productQuote.cost / 100.0, productQuote.currency);
      // }
      // return '--';
      return formatPrice(productQuote.finalCost / 100, productQuote.currency);
    },
  },
];

export const manufUnitPrice = {
  Header: 'U. Price w/o fee',
  // isNumeric: true,
  accessor: '',
  dataContentTestId: 'unit-price',
  Cell: function unitCost(productQuote: ProductQuoteApp) {
    return formatPrice(productQuote.unitCost / 100, productQuote.currency);
  },
};
